import React, { Component } from "react";
import PropTypes from "prop-types";
import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { ToastContainer } from "react-toastify";

// Redux
import { connect } from "react-redux";
import * as actions from "./redux/actions";
import { SetAxiosDefaultConfig } from "./redux/api";

import asyncComponent from "./helpers/async";
import Header from "./components/Header";
import Footer from "./components/Footer";

// Style
import "react-toastify/dist/ReactToastify.css";

// Public Rouste
const PublicRoute = [
  {
    id: "home",
    path: "/",
    exact: true,
    component: asyncComponent(() => import("./containers/Home")),
    haha: true,
  },
  {
    id: "about-us",
    path: "/about-us",
    exact: true,
    component: asyncComponent(() => import("./containers/AboutUs")),
  },
  {
    id: "contact-us",
    path: "/contact-us",
    exact: true,
    component: asyncComponent(() => import("./containers/ContactUs")),
  },
  // Agreement
  // Term Of Use
  {
    id: "terms-of-use",
    path: "/terms-and-conditions",
    exact: true,
    component: asyncComponent(() => import("./containers/AgreementTermOfUse")),
    haha: true,
  },
  // Privacy Policy
  {
    id: "privacy-policy",
    path: "/privacy-policy",
    exact: true,
    component: asyncComponent(() =>
      import("./containers/AgreementPrivacyPolicy")
    ),
    haha: true,
  },
  // Location Based Services Policy
  {
    id: "location-based-services",
    path: "/location-based-services-policy",
    exact: true,
    component: asyncComponent(() =>
      import("./containers/AgreementLocationBasedServices")
    ),
    haha: true,
  },
  // Refund and Return Policy
  {
    id: "refund-return-policy",
    path: "/refund-return-policy",
    exact: true,
    component: asyncComponent(() =>
      import("./containers/AgreementRefundAndReturn")
    ),
    haha: true,
  },
  // Merchant Terms Of Service
  {
    id: "merchant-terms-of-services",
    path: "/merchant-terms-of-services",
    exact: true,
    component: asyncComponent(() =>
      import("./containers/AgreementMerchantTermOfService")
    ),
    haha: true,
  },
  // FAQ
  {
    id: "faq",
    path: "/faq",
    exact: true,
    component: asyncComponent(() => import("./containers/FAQ")),
  },
  {
    id: "delivery-select-address",
    path: "/delivery/select-address",
    exact: true,
    component: asyncComponent(() =>
      import("./containers/DeliverySelectAddress")
    ),
  },
  // Merchant
  {
    id: "merchant-interest-form",
    path: "/merchant-interest-form",
    exact: true,
    component: asyncComponent(() =>
      import("./containers/MerchantInterestForm")
    ),
  },

  // Restaurant
  {
    id: "restaurant-list",
    path: "/restaurant/list",
    exact: true,
    component: asyncComponent(() => import("./containers/RestaurantList")),
  },
  {
    id: "restaurant-details",
    path: "/restaurant/",
    exact: true,
    component: asyncComponent(() => import("./containers/RestaurantDetails")),
    haha: true,
  },
  {
    id: "restaurant-menu",
    path: "/restaurant/:id/menu",
    exact: true,
    component: asyncComponent(() => import("./containers/RestaurantMenu")),
    haha: true,
  },
  {
    id: "restaurant-voucher",
    path: "/restaurant/:id/voucher",
    exact: true,
    component: asyncComponent(() => import("./containers/RestaurantVouchers")),
    haha: true,
  },
  // END Restaurant
  // Voucher Details
  {
    id: "voucher",
    path: "/voucher",
    exact: true,
    component: asyncComponent(() => import("./containers/VoucherDetails")),
    haha: true,
  },
  {
    id: "register-merchant",
    path: "/register-merchant",
    exact: true,
    component: asyncComponent(() => import("./containers/BecomeMerchant")),
  },
  {
    id: "upload-files",
    path: "/upload-files",
    exact: true,
    component: asyncComponent(() => import("./containers/UploadFiles")),
  },
  {
    id: "voucher-list",
    path: "/voucher/list",
    exact: true,
    component: asyncComponent(() => import("./containers/VoucherListing")),
  },
  // Mall
  {
    id: "mall",
    path: "/mall",
    exact: true,
    component: asyncComponent(() => import("./containers/Mall")),
    haha: true,
  },
  {
    id: "mall-product-list",
    path: "/mall/product/list",
    exact: true,
    component: asyncComponent(() => import("./containers/MallProductList")),
    haha: true,
  },
  {
    id: "mall-product-detail",
    path: "/mall/product/",
    exact: true,
    component: asyncComponent(() => import("./containers/MallProductDetail")),
    haha: true,
  },
  // END Mall
];

const LoggedInRoute = [
  {
    id: "my-profile",
    path: "/my-profile",
    exact: true,
    component: asyncComponent(() => import("./containers/MyProfile")),
  },
  {
    id: "cart",
    path: "/cart",
    exact: true,
    component: asyncComponent(() => import("./containers/Cart")),
  },
  {
    id: "notifications",
    path: "/notifications",
    exact: true,
    component: asyncComponent(() => import("./containers/NotificationList")),
  },
  {
    id: "my-profile",
    path: "/my-profile",
    component: asyncComponent(() => import("./containers/MyProfile")),
  },
  {
    id: "mall-order-summary",
    path: "/mall/order-summary",
    exact: true,
    component: asyncComponent(() => import("./containers/MallOrderSummary")),
    haha: true,
  },
  {
    id: "my-order-details",
    path: "/my-profile/?tabs=my-order/restaurant/:status",
    exact: true,
    component: asyncComponent(() => import("./containers/MallOrderSummary")),
    haha: true,
  },
  {
    id: "voucher-checkout",
    path: "/voucher/:id/checkout",
    exact: true,
    component: asyncComponent(() => import("./containers/VoucherCheckOut")),
  },
  {
    id: "checkout",
    path: "/restaurant/:id/checkout",
    exact: true,
    component: asyncComponent(() => import("./containers/OrderSummary")),
  },
];

const LoggedOutRoute = [
  {
    id: "register",
    path: "/register",
    exact: true,
    component: asyncComponent(() => import("./containers/Register")),
  },
  {
    id: "invite",
    path: "/invite",
    exact: true,
    component: asyncComponent(() => import("./containers/Register")),
  },
  {
    id: "signup",
    path: "/signup",
    exact: true,
    component: asyncComponent(() => import("./containers/Register")),
  },
];

class AppRouter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authVerified: false,
    };
  }

  componentDidMount() {
    SetAxiosDefaultConfig();

    if (!this.props.isDeviceRegistered) {
      this.props.onRegisterDevice();
    } else if (this.props.uuid) {
      // refresh device register if previously registered before
      this.props.onRegisterDevice(this.props.uuid);
    }

    // If logged in, refresh login token when first load
    if (this.props.jwt_token === null) {
      this.setState({ authVerified: true });
    } else {
      // First time load call relogin to refresh token
      this._onRelogin();
      this._onReloginInterval();
    }

    // cannot do this as this will renew uuid every time thus the web will logout due to uuid not the same
    // this.props.onRegisterDevice();

    if (this.props.isLoggedIn || this.props.isDeviceRegistered) {
      if (this.props.isFirstLoad) {
        this.props.onGetListLocation();
      }
    }
    this.props.getPhoneNo();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.jwt_token !== this.props.jwt_token) {
      if (this.props.jwt_token !== null) {
        this._onReloginInterval();
        this.props.onGetListLocation();
        if (this.props.isLoggedIn) {
          this._loadConsumerProfileData();
        }
      } else {
        clearInterval(this.reloginInterval);
      }
    }

    if (prevProps.refreshToken !== this.props.refreshToken) {
      if (this.props.refreshToken) {
        this.setState({ authVerified: true });
      }
    }

    if (prevProps.isDeviceRegistered !== this.props.isDeviceRegistered) {
      if (this.props.isDeviceRegistered) {
        this.props.onGetListLocation();
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    clearInterval(this.reloginInterval);
  }

  _loadConsumerProfileData = () => {
    this.props.onGetConsumerProfileDetails();
    this.props.onGetNotificationCount();
    this.props.onGetMallCart();
    // this.interval = setInterval(() => {
    //   this.props.onGetNotificationCount();
    // }, 30000);
  };

  _onReloginInterval = () => {
    // Call relogin every one hour
    this.reloginInterval = setInterval(() => {
      this._onRelogin();
    }, 3600000);
  };

  _onRelogin = () => {
    let params = {
      app_token: "LOLOL-CONSUMER-WEB",
      uuid: this.props.uuid,
    };

    this.props.onRelogin(params);
  };

  render() {
    const { isDeviceRegistered, isLoggedIn, isLoading } = this.props;
    const { authVerified } = this.state;

    let routes = [
      ...PublicRoute,
      ...(isLoggedIn ? LoggedInRoute : LoggedOutRoute),
      {
        component: asyncComponent(() => import("./containers/NotFound")),
        id: "not_found",
      },
    ];

    return !isDeviceRegistered || !authVerified ? (
      <div id="preloader">
        <div className="sk-spinner sk-spinner-wave">
          <div className="sk-rect1" />
          <div className="sk-rect2" />
          <div className="sk-rect3" />
          <div className="sk-rect4" />
          <div className="sk-rect5" />
        </div>
      </div>
    ) : (
      <BrowserRouter>
        <ConnectedRouter history={this.props.history}>
          {isLoading && (
            <div className="loader-overlay">
              <div className="loader" />
            </div>
          )}
          <Header whatsapp_no={this.props.whatsapp_no} />
          <Switch>
            {routes.map((route) => {
              return (
                <Route
                  key={route.id}
                  path={route.path}
                  exact={route.exact}
                  component={route.component}
                  {...route}
                />
              );
            })}
            <Redirect to="/" />
          </Switch>
           
          <Footer
            hotline_no={this.props.hotline_no}
            whatsapp_no={this.props.whatsapp_no}
          />
          <ToastContainer />
        </ConnectedRouter>
      </BrowserRouter>
    );
  }
}

AppRouter.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isDeviceRegistered: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  jwt_token: PropTypes.any,
  isFirstLoad: PropTypes.bool.isRequired,
  // Function
  onRegisterDevice: PropTypes.func.isRequired,
  onGetNotificationCount: PropTypes.func.isRequired,
  onGetConsumerProfileDetails: PropTypes.func.isRequired,
  onGetMallCart: PropTypes.func.isRequired,
  onGetListLocation: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.App.isLoading,
    hotline_no: state.App.hotline_no,
    whatsapp_no: state.App.whatsapp_no,
    refreshToken: state.Auth.refreshToken,
    isDeviceRegistered: state.Auth.isDeviceRegistered,
    isLoggedIn: state.Auth.isLoggedIn,
    jwt_token: state.Auth.jwt_token,
    device_token: state.Auth.device_token,
    uuid: state.Auth.uuid,
    isFirstLoad: state.IsFirstLoad.isFirstLoad,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRegisterDevice: (params) => dispatch(actions.registerDevice(params)),
    onRelogin: (params) => dispatch(actions.consumerRelogin(params)),
    onGetNotificationCount: () => dispatch(actions.getNotificationCount()),
    onGetConsumerProfileDetails: () =>
      dispatch(actions.getConsumerProfileDetails()),
    onGetMallCart: () => dispatch(actions.mallLoadCart()),
    onGetListLocation: () => dispatch(actions.getLocationList()),
    getPhoneNo: () => dispatch(actions.getPhoneNo()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);
